import indexpb from './index.pb';
import lang from '../../lang/index';
import url from 'c-url';
import { safeAjax } from '../api';

let visitor = {
    register() {

        let _lang = lang.type;
        let countryCode = _lang.split('-')[1].toUpperCase();

        return new Promise((resolve, reject) => {
            safeAjax({
                config: {
                    api: '/visitor/register/h5',
                },
                params: {
                    countryCode,
                    deviceId: url.query('deviceId')
                },
                pbObj: indexpb.Visitor.RegisterH5
            }).then(data => {
                // cache.setCache('user', {
                //     uid: longToString(data.profile.uid),
                //     userToken: data.profile.userToken,
                //     subscribe: data.profile.subscribe
                // });
                //
                // cache.setCache('isVisitor', true);
                // $.channel.emit('registerVisitorSuccess');
                resolve(data.profile);
            }).catch(reject);
        });
    }
};

export default visitor;



// WEBPACK FOOTER //
// ./js/component/visitor/index.js